import { render, staticRenderFns } from "./vip-choose.vue?vue&type=template&id=789b8a02&scoped=true&"
import script from "./vip-choose.vue?vue&type=script&lang=js&"
export * from "./vip-choose.vue?vue&type=script&lang=js&"
import style0 from "./vip-choose.vue?vue&type=style&index=0&id=789b8a02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b8a02",
  null
  
)

export default component.exports